<template>
  <a-swiper
    :swipe-list="clients"
    :custom-options="swiperOptions"
    :display-arrows="false"
    :pagination="true"
    :swiper-pagination-custom-class="$options.consts.SWIPER_PAGINATION_CLASS"
    class="qir-clients-slider__wrapper"
  >
    <div slot-scope="{ slide }" class="qir-clients-slider__slide-wrapper">
      <a-image
        :src="slide.imageUrl"
        :alt="slide.altText"
        class="qir-clients-slider__slide-image"
      />
    </div>

    <div
      slot="bullets"
      class="swiper-pagination swiper-pagination-bullets"
      :class="$options.consts.SWIPER_PAGINATION_CLASS"
    />
  </a-swiper>
</template>

<script>
import ASwiper from 'shared/ASwiper/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

const SWIPER_PAGINATION_CLASS =
  'qir-clients-slider__swiper-pagination-container'

export default {
  name: 'QirClientsSlider',
  components: { ASwiper },
  props: {
    clients: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    SWIPER_PAGINATION_CLASS
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 32,
        pagination: false,
        breakpoints: {
          [this.$breakpoint.mobile]: {
            spaceBetween: 24
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qir-clients-slider__wrapper {
  $margin-right: (
    $above-desktop-xl: -#{$padding-x-desktop-full-hd},
    $desktop-md: -#{$padding-x-desktop-md},
    $mobile: -#{$padding-x-mobile}
  );

  @include setStyleByBreakpoint('margin-right', $margin-right);

  /deep/ .swiper__custom-swiper {
    margin: 0;
  }

  .qir-clients-slider__slide-wrapper,
  /deep/ .swiper__list__item {
    $width: (
      $above-desktop-xl: 150px
    );

    $height: (
      $above-desktop-xl: 100px
    );

    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('width', $width);
  }

  .qir-clients-slider__slide-wrapper {
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $c--black;
  }

  .qir-clients-slider__slide-image {
    width: auto;
  }

  /deep/ .a-image__link {
    display: flex;
    height: 100%;
  }

  /deep/ .swiper__custom-swiper {
    width: 100%;
  }
}
</style>
